import React from 'react';
import useStyle from './featureClassManager.style';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { ClasseDefWithUser } from '../../../../types/classe/classe.def';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import FormatDisplayDate from '../../../atoms/DisplayDate/FormatDisplayDate';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { HeaderText } from '../../../atoms/Texts/HeaderText';
import { Hammer } from '../../../../theme/emoji';
import { ClassManagerBlock } from '../../../molecules/Blocks/ClassManagerBlock';
import { CSVEleveResultsTypes } from 'types/user/eleve.def';

interface FeatureClassManagerViewProps {
  classe: ClasseDefWithUser;
  nbProf: number;
  nbEleve: number;
  toggleOpen: (type) => void;
  needHelp: () => void;
  handleChange: (results: CSVEleveResultsTypes) => Promise<void>;
}

export const FeatureClassManagerView = ({
  classe,
  nbProf,
  nbEleve,
  toggleOpen,
  needHelp,
  handleChange
}: FeatureClassManagerViewProps) => {
  const classes = useStyle();
  return (
    <FeatureContainer
      buttonWithText={
        <ButtonWithText
          icon={'Interogation'}
          iconColor={'#959595'}
          content={"J'ai besoin d'aide !"}
          variant={'text'}
          onClick={needHelp}
        />
      }
      buttonPosition={'topRight'}
      withPadding={true}
    >
      <div className={classes.block1}>
        <h3 className={classes.title}>
          {classe?.name} du lycée {classe?.lycee?.name}
        </h3>
        <div className={classes.infos}>
          <FlatIcon color={'#959595'} icon={'Users'} />
          <p className={classes.text}>
            {nbEleve} élève(s) et {nbProf} professeur(es){'\u00A0'}🧑‍🏫
          </p>
        </div>
        <div className={classes.infos}>
          <FlatIcon color={'#959595'} icon={'Calendar'} />
          <p className={classes.dateText}>
            Du <FormatDisplayDate date={classe?.debut} /> au{' '}
            <FormatDisplayDate date={classe?.fin} />
          </p>
        </div>
      </div>
      <HeaderText text={'Gestion de la classe'} emoji={Hammer} />
      <div className={classes.block2}>
        <ClassManagerBlock
          variant={'indiv'}
          label={'Créez votre classe individuellement'}
        />
        <ClassManagerBlock
          variant={'masse'}
          label={'Ou créez votre classe EN MASSE (2 étapes)'}
          classeName={classe?.operationid}
          onChange={handleChange}
        />
      </div>
    </FeatureContainer>
  );
};
